import { c as _c } from "react/compiler-runtime";
export default function Recognition(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M76.02 36.01C76.02 20.565 63.456 8 48.01 8 32.565 8 20 20.565 20 36.01c0 7.258 2.776 13.879 7.32 18.86V85c0 1.165.654 2.202 1.706 2.704a2.98 2.98 0 0 0 3.184-.377l15.83-12.859 15.831 12.86a2.99 2.99 0 0 0 3.183.377A2.973 2.973 0 0 0 68.76 85V54.805c4.51-4.973 7.26-11.569 7.26-18.795zM48.01 10c14.343 0 26.01 11.668 26.01 26.01 0 14.343-11.667 26.01-26.01 26.01C33.668 62.02 22 50.352 22 36.01 22 21.67 33.668 10 48.01 10zm18.182 75.899a.98.98 0 0 1-1.061-.125l-16.46-13.37a.999.999 0 0 0-1.261 0L30.95 85.773a.978.978 0 0 1-1.064.126.974.974 0 0 1-.567-.898V56.85c4.961 4.453 11.514 7.169 18.69 7.169 7.205 0 13.781-2.736 18.75-7.221v28.202c0 .393-.212.729-.568.898z" fill="currentColor" />;
    t2 = <path d="M38.936 40.228l-1.272 7.387a2.54 2.54 0 0 0 1.024 2.492c.79.57 1.814.64 2.677.188L48 46.81l6.634 3.484c.377.2.786.297 1.192.297.527 0 1.052-.166 1.5-.492a2.524 2.524 0 0 0 1.009-2.489l-1.27-7.382 5.365-5.233c.7-.685.946-1.689.641-2.618a2.528 2.528 0 0 0-2.057-1.727l-7.41-1.074-3.318-6.72a2.537 2.537 0 0 0-2.285-1.419c-.977 0-1.853.544-2.288 1.42l-3.317 6.72-7.406 1.073a2.528 2.528 0 0 0-2.06 1.726c-.306.93-.06 1.933.642 2.62l5.364 5.232zM34.83 33a.531.531 0 0 1 .443-.37l7.93-1.149a1 1 0 0 0 .754-.547l3.549-7.189a.537.537 0 0 1 .494-.306c.103 0 .356.03.494.306l3.55 7.19a1 1 0 0 0 .753.546l7.933 1.15c.302.043.409.273.44.37a.538.538 0 0 1-.138.564l-5.74 5.6c-.235.23-.343.561-.287.885l1.36 7.903a.529.529 0 0 1-.217.53.54.54 0 0 1-.584.042l-7.1-3.73a.997.997 0 0 0-.929 0l-7.101 3.73a.53.53 0 0 1-.575-.039.54.54 0 0 1-.224-.535l1.36-7.9a.999.999 0 0 0-.286-.886l-5.74-5.599a.538.538 0 0 1-.14-.566z" fill="currentColor" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg aria-hidden={true} className={className} fill="none" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}